import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../shared/my-constants';

//  import * as webapi from '../../assets/js/webproperty.js';
@Injectable()
export class TokenListService {
    city: any;
    hasCreateAccess = true;
    hasEditAccess = true;
    hasDeleteAccess = true;
    private headers = new Headers({'Content-Type': 'application/json'});
    private loginurl = webapi + 'loginaction/authuser/';

    constructor(private http: Http) {
    }

    loginaction(value): Promise<any> {
        let headers = new Headers({'Content-Type': 'application/json'});
        return this.http.post(this.loginurl, JSON.stringify(value), {headers: headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-list/token-list.service.ts